import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Gmail Send Email v3 Configuration Validator
 * Validates Gmail email configuration including connection, recipients, and content
 */
export const Gmail_Send_Email_3_ConfigValidator = z.object({
    gmailConnection: requiredString('Gmail Connection is required'),
    emailFrom: requiredString('From Email is required'),
    emailTo: requiredString('To Email is required'),
    emailCc: z.string().optional(),
    emailSubject: requiredString('Email Subject is required'),
    emailBody: requiredString('Email Body is required'),
    emailHasSignature: z.boolean().default(false)
});
//# sourceMappingURL=gmail-send-email-3.js.map